import { CanActivateFn } from '@angular/router';

export const safetyTipsGuard: CanActivateFn = () => {
  return true;
};
